/*
 * Public API Surface of kraken-slider
 */

export * from './lib/kraken-slider.service';
export * from './lib/kraken-slider.component';
export * from './lib/kraken-slider.module';
